<template>
  <div
    v-show="isVisible"
    class="configurator-card-element-wrapper"
    :id="'card' + p_selectionCard.id"
    v-bind:class="isPreferenced ? 'recommended-card-element' : ''"
    v-bind:disabled="isDisabled"
  >
    <div class="configurator-card-element-gallery-link">
      <div
        class="configurator-card-element-image-area lightbox-able"
        v-bind:class="p_selectionCard.id + '_lightbox'"
      >
        <br />
        <div
          v-for="(image, index) in computedImages"
          v-bind:key="index"
          class="configurator-card-element-single-image-wrapper"
          v-bind:class="image.isVisible ? 'visible-image' : 'hidden-image'"
        >
          <a v-bind:href="url + image.image" @click="checkIfDeactivatedCard($event)" class="configurator-card-element-image-link" title="Bildunterschrift">
            <img
              width="75"
              height="75"
              v-bind:src="url + image.image"
              v-bind:alt="image.name"
              @load="imageLoaded(index)"
              class="configurator-card-element-single-image"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="configurator-card-element-image-arrow-wrapper">
      <i
        @click="prevImage"
        v-if="!noPrevAndNextButton"
        class="fal fa-caret-left configurator-card-element-image-prev"
      ></i>
      <i
        @click="nextImage"
        v-if="!noPrevAndNextButton"
        class="fal fa-caret-right configurator-card-element-image-next"
      ></i>
    </div>
    <div class="configurator-card-element-text-area">
      <div
        v-if="p_selectionCard.name"
        class="configurator-card-element-headline-wrapper"
      >
        <h4 class="configurator-card-element-headline">
          {{ p_selectionCard.name }}
        </h4>
      </div>
      <div class="configurator-card-element-text-wrapper">
        <div
          v-if="isDisabled"
          class="configurator-hover-icon card-hover-element"
        >
          <span
            @mouseover="isDisableTextHovering = true"
            @mouseout="isDisableTextHovering = false"
            class="configurator-hover-icon-label brand-color-text"
            >Wieso ist diese Option deaktiviert?</span
          >
          <i
            @mouseover="isDisableTextHovering = true"
            @mouseout="isDisableTextHovering = false"
            class="fal fa-info-circle brand-color-text"
          ></i>
        </div>
        <div
          v-if="isPreferenced"
          class="configurator-hover-icon card-hover-element brand-color-text"
        >
          <span
            @mouseover="isPreferencedTextHovering = true"
            @mouseout="isPreferencedTextHovering = false"
            class="configurator-hover-icon-label"
            >Wieso wird diese Option empfohlen?</span
          >
          <i
            @mouseover="isPreferencedTextHovering = true"
            @mouseout="isPreferencedTextHovering = false"
            class="fal fa-info-circle"
          ></i>
        </div>
        <div v-html="p_selectionCard.description"></div>
        <div v-bind:key="index" v-for="(dropdown, index) in dropdowns" class="dropdown">
          <button v-bind:id="'dropbtn_'+ index" class="dropbtn" @click="dropDownCollapsible($event)">
            {{ dropdowns[index][0].dropdownPlaceholder }}
          </button>
          <div class="dropdown-content" v-bind:id="'dropdown'+ p_selectionCard.id + '_' + index ">
            <template v-for="(dropdownValue, indexContent) in dropdowns[index]">
              <a
                v-bind:key="indexContent"
                ref="dropdownItem"
                class="dropdown-item"
                @click="dropdownElementClicked(index, dropdownValue), closeDropDownContent($event)"
                >{{ dropdownValue.dropdownValueName }}</a>
            </template>
          </div>
        </div>
      </div>
      <div class="configurator-card-element-hover-wrapper">
        <div class="configurator-card-element-hover-content-wrapper">
          <div
            v-html="overlayText"
            v-bind:style="{ display: isOverlayHovering ? 'block' : 'none' }"
            class="configurator-card-element-hover-area"
            v-bind:class="isOverlayHovering ? 'fade-in-text-hover' : ''"
          ></div>
          <div
            v-html="p_selectionCard.disableText"
            v-bind:style="{ display: isDisableTextHovering ? 'block' : 'none' }"
            class="configurator-card-element-hover-area"
            v-bind:class="isDisableTextHovering ? 'fade-in-text-hover' : ''"
          ></div>
          <div
            v-html="p_selectionCard.preferenceText"
            v-bind:style="{
              display: isPreferencedTextHovering ? 'block' : 'none'
            }"
            class="configurator-card-element-hover-area configurator-card-element-hover-area-preferenced"
            v-bind:class="isPreferencedTextHovering ? 'fade-in-text-hover' : ''"
          ></div>
        </div>
      </div>
    </div>
    <Button
      v-bind:p_label="p_selectionCard.buttonText"
      p_customClass="configurator-card-element-button"
      p_notDisabledCustomClass="brand-color"
      v-bind:p_iconTick="p_selectionCard.iconTick"
      v-if="!isDisabled"
      v-bind:p_disabled="isButtonDisabled"
    />
    <div
      v-if="p_linkedProduct"
      class="configurator-card-element-price-tag-wrapper"
    >
      <div class="configurator-card-element-price-tag">
        <span id="{$customID}PriceTag">XXX,XX</span
        ><template v-if="!p - noPrice">€</template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Button from "./Button";
import * as magnificPopupJQuery from "../../assets/magnific-popup-1.1.0/jquery.magnific-popup.js";

const urlValidateRuleRest =
  process.env.URL_BACKEND + process.env.REST_RULE_VALIDATE_RULE;
const urlDropdownElementRest =
  process.env.URL_BACKEND +
  process.env.REST_DROPDOWN_ELEMENTS_READ_DROPDOWN_ELEMENTS;
const urlMediaReadRest =
  process.env.URL_BACKEND + process.env.REST_MEDIA_READ_MEDIA;

export default {
  components: { Button },
  props: {
    p_index: Number,
    p_selectionCard: {},
    p_headlineIcon: {
      default: true,
      type: Boolean
    },
    p_linkedProduct: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      actualImage: 0,
      computedImages: [],
      noPrevAndNextButton: false,
      url: process.env.URL_BACKEND,
      dropdowns: [],
      actualDropdownValues: [],
      actualDropdownIds: [],
      isVisible: false,
      isDisabled: false,
      isButtonDisabled: false,
      isDisableTextHovering: false,
      isPreferenced: false,
      isPreferencedTextHovering: false,
      isOverlayHovering: false,
      overlayText: "",
      imagesLoaded: [],
      allImagesLoaded: false
    };
  },
  beforeMount() {
    // Check if images are stored
    if (
      this.p_selectionCard.media != null &&
      this.p_selectionCard.media.length > 0
    ) {
      // LoadMedia
      const json = JSON.stringify({
        affectedMedia: { id: this.p_selectionCard.media }
      });
      axios
        .post(urlMediaReadRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          if (Array.isArray(result.data)) {
            result.data.forEach(element => {
              this.computedImages.push({
                name: element.name,
                image: element.path,
                isVisible: false
              });
              this.imagesLoaded.push(false);
            });
          } else {
            this.computedImages.push({
              name: element.name,
              image: result.data.path,
              isVisible: false
            });
            this.imagesLoaded.push(false);
          }
          this.computedImages[0].isVisible = true;
        }).finally(() => {
          if (this.imagesLoaded.length == 1) {
            this.noPrevAndNextButton = true;
          }
          else {
            this.noPrevAndNextButton = false;
          }
        });
    }
  },
  mounted() {
    const lightboxClass =
      ".configurator-card-element-image-area.lightbox-able." +
      this.p_selectionCard.id +
      "_lightbox";
    // JQuery Code for magnificPopup
    $(lightboxClass).magnificPopup({
      delegate: "a",
      type: "image",
      tLoading: "Lade #%curr%...",
      tClose: "Schließens (Esc)",
      mainClass: "mfp-img-mobile",
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        tCounter: "",
        tPrev: "Vorheriges Bild",
        tNext: "Nächstes Bild"
      },
      image: {
        tError:
          '<a href="%url%">Das Bild #%curr%</a> konnte nicht geladen werden.',
        titleSrc: function(item) {
          return item.el.attr("title");
        }
      }
    });

    // Get all OverlayElements and add a mouseover and mouseout function
    let overlayAArray = this.$el.getElementsByClassName("overlay-a");
    for (let overlayAElement of overlayAArray) {
      overlayAElement.setAttribute(
        "class",
        overlayAElement.getAttribute("class") + " brand-color-text"
      );
      overlayAElement.addEventListener(
        "mouseover",
        this.showOverlay.bind(this, overlayAElement.id)
      );
      overlayAElement.addEventListener("mouseout", this.hideOverlay);
    }
  },
  methods: {
    checkIfDeactivatedCard(event) {
      if($(event.target).parents(".configurator-card-element-wrapper").attr("disabled") != undefined) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    executeButton() {
      // If there was no tick before
      // set all following steps to not accessible
      if (this.p_selectionCard.iconTick == "") {
        this.$parent.setNextStepsToNotAccessible();
      }
      this.$parent.resetTicks();
      this.$parent.setTick(this.p_selectionCard.id);
      let tmpValues = [];
      this.p_selectionCard.values.forEach(element => {
        element.selectionCardId = this.p_selectionCard.id;
        tmpValues.push(element);
      });
      // Product specific values
      // stored to the first value of the selectionCard
      tmpValues[0].articleIds = this.p_selectionCard.articleIds;
      tmpValues[0].articleQuantities = this.p_selectionCard.articleQuantities;
      // tmpValues.push(this.p_selectionCard.values[0]);
      if (this.dropdowns.length > 0) {
        let index = 0;
        this.dropdowns.forEach( dropdown => {
          let tmpDropdownValueIndex = 0;
          // Get the index of the selected dropdownValue
          for (let i = 0; i < dropdown.length; ++i) {
            if (dropdown[i].dropdownValueId == this.actualDropdownIds[index]) {
              tmpDropdownValueIndex = i;
              break;
            }
          }
          tmpValues.push({
            selectionCardId: this.p_selectionCard.id,
            attributeId: this.p_selectionCard.values[0].attributeId,
            attributeName: this.p_selectionCard.values[0].attributeName,
            attributeVisible: this.p_selectionCard.values[0].attributeVisible,
            name: this.p_selectionCard.values[0].name,
            value: dropdown[0].dropdownName,
            valueName: dropdown[tmpDropdownValueIndex].dropdownValueName,
            dropdownId: this.actualDropdownIds[index],
            type: "select"
          });
          // For custom products in Main.vue
          tmpValues.push({
            selectionCardId: this.p_selectionCard.id,
            attributeId: this.p_selectionCard.values[0].attributeId,
            attributeName: "concat_val",
            attributeVisible: 0,
            value: this.actualDropdownValues[index],
            valueName: this.actualDropdownValues[index],
            dropdownId: this.actualDropdownIds[index],
            type: "select"
          });
          ++index;
        });
      }
      this.$parent.saveStepValue(tmpValues);
      this.$parent.goToNextStep();
    },
    prevImage() {
      // Are images loaded?
      if (this.computedImages != null && this.computedImages.length > 0) {
        this.computedImages[this.actualImage].isVisible = false;
        // If the actualImage is below the first image go to the last image
        if (this.actualImage - 1 < 0)
          this.actualImage = this.computedImages.length - 1;
        else this.actualImage -= 1;
        this.computedImages[this.actualImage].isVisible = true;
      }
    },
    nextImage() {
      // Are images loaded?
      if (this.computedImages != null && this.computedImages.length > 0) {
        this.computedImages[this.actualImage].isVisible = false;
        // If the actualImage is behind the last image go to the first image
        if (this.actualImage + 1 >= this.computedImages.length)
          this.actualImage = 0;
        else this.actualImage += 1;
        this.computedImages[this.actualImage].isVisible = true;
      }
    },
    imageLoaded(index) {
      this.imagesLoaded[index] = true;
      let allImagesLoaded = true;
      this.imagesLoaded.forEach(element => {
        if (!element) {
          allImagesLoaded = false;
        }
      });
      this.allImagesLoaded = allImagesLoaded;
      if (this.allImagesLoaded) {
        this.$parent.setSelectionCardReady(this.p_index);
      }
    },
    getDropdownElement() {
      if (this.p_selectionCard.dropdownElementIds != null) {
        this.p_selectionCard.dropdownElementIds.split(";").forEach(dropdownElementId => {
          let tmpDropdownElements = [];
          let json = {
            affectedDropdownElement: {}
          };
          json.affectedDropdownElement.id = dropdownElementId;
          json = JSON.stringify(json);
          // Call REST readDropdownElement
          axios
            .post(urlDropdownElementRest, json, {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json"
              }
            })
            .then(result => {
              result.data.forEach(dropdownValue => {
                this.isButtonDisabled = true;
                let tmpDropdownValue = {
                  dropdownName: dropdownValue.dropdown_name,
                  dropdownPlaceholder: dropdownValue.dropdown_placeholder,
                  dropdownValueId: dropdownValue.dropdown_value_id,
                  dropdownValueName: dropdownValue.dropdown_value_name,
                  dropdownValueValue: dropdownValue.dropdown_value_value
                };
                tmpDropdownElements.push(tmpDropdownValue);
              });
            })
            .finally(() => {
              // Add to a new dropdown
              this.dropdowns.push(tmpDropdownElements);
              this.actualDropdownValues.push("");
              this.actualDropdownIds.push(-1);
              // Functionality of the dropdown button
              // first get the button
              let dropdownButton = this.$el.getElementsByClassName("dropbtn");
              if (dropdownButton != null && dropdownButton.length > 0) {
                let dropdownContent = this.$el.getElementsByClassName(
                  "dropdown-content"
                );
                dropdownButton[0].onmouseenter = function() {
                  // set the width of the content elements
                  let width = dropdownButton[0].offsetWidth;
                  // dropdownContent[0].setAttribute("style", "width:20px");
                  dropdownContent[0].style.width = width + "px";
                };
              }
            });
        });
      }
      return null;
    },
    resetDropdown() {
      // Set the placeholder text and the button to disabled
      this.isButtonDisabled = true;
      if (typeof this.$el.getElementsByClassName != "undefined") {
        let dropdownButtons = this.$el.getElementsByClassName("dropbtn");
        for (let i = 0; i < dropdownButtons.length; ++i) {
          dropdownButtons[i].innerHTML = this.dropdowns[i][0].dropdownPlaceholder
        }
      }
    },
    setDropdown(dropdownId) {
      // This method is called during the load configuration settings
      this.isButtonDisabled = false;
      // this.actualDropdownId = dropdownId;
      for (let i = 0; i < this.dropdowns.length; ++i) {
        for (let k = 0; k < this.dropdowns[i].length; ++k) {
          if (this.dropdowns[i][k].dropdownValueId == dropdownId) {
            this.actualDropdownIds[i] = dropdownId;
            this.actualDropdownValues[i] = this.dropdowns[i][k].dropdownValueValue;
            this.$el.getElementsByClassName("dropbtn")[i].innerHTML = this.dropdowns[i][k].dropdownValueName;
          }
        }
      }
    },
    dropdownElementClicked(index, dropdownValue) {
      this.isButtonDisabled = false;
      this.actualDropdownValue = dropdownValue.dropdownValueValue;
      this.actualDropdownIds[index] = dropdownValue.dropdownValueId;
      this.actualDropdownValues[index] = dropdownValue.dropdownValueValue;
      // Check if all dropdowns in one selectionCard have values
      // if not set button disabled
      this.actualDropdownValues.forEach(actualDropdownValue => {
        if (actualDropdownValue == "") {
          this.isButtonDisabled = true;
        }
      });
      let dropbtn = this.$el.getElementsByClassName("dropbtn");
      dropbtn[index].innerHTML = dropdownValue.dropdownValueName;

    },
    getExecutionAxios(ruleId) {
      if (ruleId != null) {
        let json = {
          rule: {},
          validationValues: {}
        };
        json.rule.id = ruleId;
        this.$store.state.stepValues.forEach(stepValue => {
          if (stepValue.attributeId > 0) {
            json.validationValues[stepValue.attributeName] = stepValue.value;
          }
        });
        json = JSON.stringify(json);
        // Call REST validaterule
        return axios({
          method: "post",
          url: urlValidateRuleRest,
          data: json,
          headers: {
            "Content-Type": "application/json"
          }
        });
      }
      return null;
    },
    setVariable(variable, value) {
      // Set the variable dynamically via string
      this[variable] = value;
    },
    getVisibleAxios() {
      return this.getExecutionAxios(this.p_selectionCard.visibleRuleId);
    },
    getDisableAxios() {
      return this.getExecutionAxios(this.p_selectionCard.disableRuleId);
    },
    getPreferenceAxios() {
      return this.getExecutionAxios(this.p_selectionCard.preferenceRuleId);
    },
    showOverlay(overlayAId) {
      this.isOverlayHovering = true;
      let overlayArray = this.$el.getElementsByClassName("overlay");
      for (let overlayElement of overlayArray) {
        if (overlayElement.id == overlayAId) {
          this.overlayText = overlayElement.innerHTML;
        }
      }
    },
    hideOverlay() {
      this.isOverlayHovering = false;
    },
    dropDownCollapsible(event){
      var collapseSection = $(event.target).siblings(".dropdown-content");
      if ($(collapseSection).css("display") === "none"){
        $(collapseSection).css("display", "block");
        $(event.target).addClass("open");
      } else{
        $(collapseSection).css("display", "none");
        $(event.target).removeClass("open");
      }

      let sorroundingDiv = $(event.target).parents('.configurator-card-element-text-wrapper');
      sorroundingDiv.scrollTop(sorroundingDiv.scrollTop() + 150);
    },
    closeDropDownContent(event){
      var collapseSection = $(event.target).parents(".dropdown-content");
      if ($(collapseSection).css("display") === "none"){
        $(collapseSection).css("display", "block");
        $(collapseSection.siblings(".dropbtn")).addClass("open");
      } else{
        $(collapseSection).css("display", "none");
        $(collapseSection.siblings(".dropbtn")).removeClass("open");
        }
    },
  }
};
</script>

<style language="css">
@import "../../scss/selection_card/style.css";
</style>



// WEBPACK FOOTER //
// src/components/configurator/SelectionCard.vue